import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { TinymceService } from '../tinymce.service';

@Component({
    selector: 'clink-media-upload',
    templateUrl: './media-upload.component.html',
    styleUrls: ['./media-upload.component.less'],
})
export class MediaUploadComponent implements OnInit {
    static config: any = {
        nzContent: MediaUploadComponent,
        nzMaskClosable: false,
        nzWidth: 835,
        nzFooter: null,
        nzComponentParams: {
            data: {},
        },
    };
    finalSelects: any = []; // 最终选择的图片，数据库 or uploader 上传的
    selectedFiles: any = []; // 选择数据库中的视频文件
    @Input() data;
    uploader: FileUploader;
    uploadDatas: any = []; // 读取uploader
    limit = 5; // 上传数量限制
    constructor(
        public modalRef: NzModalRef<MediaUploadComponent>,
        private detector: ChangeDetectorRef,
        private tinymceService: TinymceService,
        private message: NzMessageService,
        private modal: NzModalService,
    ) {}

    ngOnInit(): void {
        const options: FileUploaderOptions = {
            url: this.data.uploadUrl, // 上传地址--string
            method: 'POST', // 上传文件的方式--string
            itemAlias: this.data.file, // 文件标记、别名--string
            headers: [{ name: 'accept', value: 'application/json' }], // 上传文件的请求头参数--Array<headers>
            removeAfterUpload: true, // 是否在上传完成后从队列中移除--boole
        };
        this.uploader = new FileUploader(options);
    }

    /**
     * @desc 选择视频
     *
     * @memberof MediaUploadComponent
     */
    selectedFileOnChanged(): void {
        const { queue } = this.uploader;
        if (queue && queue.length > 0) {
            let num = 0;
            queue.forEach((item, index) => {
                if (item.file) {
                    if (!this.tinymceService.isValidVideo(item.file, false)) {
                        this.message.warning('视频大小超过限制！');
                        queue.splice(index, 1);
                        num -= -1;
                    }
                }
            });
            if (num > 0) {
                this.modal.warning({
                    nzTitle: `已自动为您过滤掉${num}张不符合视频格式的文件`,
                    nzContent: '',
                    nzOkText: '确定',
                    nzOkType: 'primary',
                    nzCancelText: '取消',
                });
            }
            // balance 超过的视频数量
            const balance = queue.length - this.limit;
            if (balance > 0) {
                queue.splice(-balance, balance);
                this.modal.warning({
                    nzTitle: `已自动为您过滤掉超过${balance}张的视频`,
                    nzContent: '',
                    nzOkText: '确定',
                    nzOkType: 'primary',
                    nzCancelText: '取消',
                });
            }

            // 读取queue中的文件数据，显示视频名称
            const list = [];
            queue.forEach((val, i, array) => {
                const fileReader = new FileReader();
                fileReader.onloadend = (e) => {
                    const imageData = fileReader.result;
                    list.push(imageData);
                };
                fileReader.readAsDataURL(val._file);
            });
            this.uploadDatas = list;
        }
    }

    /**
     * @desc 删除视频
     *
     * @param {number} index
     * @memberof MediaUploadComponent
     */
    removeUploadFile(index: number): void {
        const { queue } = this.uploader,
            len = queue.length;
        if (len === this.uploadDatas.length && len > index) {
            queue.splice(index, 1);
            this.uploadDatas.splice(index, 1);
        }
    }

    /**
     * @desc 视频上传
     *
     * @memberof MediaUploadComponent
     */
    uploadAllFiles(): void {
        const { queue } = this.uploader;
        const self = this;
        const list = [];
        if (queue) {
            this.uploader.onSuccessItem = (item, response, status, headers) => {
                if (status >= 200 && status < 300) {
                    // 上传文件后获取服务器返回的数据
                    const tempRes = JSON.parse(response);
                    list.push(tempRes.result[0]);
                } else {
                    // 上传文件后获取服务器返回的数据错误
                    this.message.error('视频上传失败');
                }
            };
            this.uploader.onErrorItem = (item, response, status, headers) => {
                self.message.error('视频上传失败, 请检查网络是否连接');
            };
            this.uploader.uploadAll(); // 开始上传
        }
        this.uploader.onWhenAddingFileFailed = (item, filter) => {
            this.message.error('视频上传失败，请检查网络是否连接');
        };
        // 上传ing
        this.uploader.onProgressAll = (progress: any) => {
            // 变更检测，更新视图
            this.detector.detectChanges();
        };
        // 上传完毕
        this.uploader.onCompleteAll = () => {
            this.finalSelects.splice(0, this.finalSelects.length);
            this.finalSelects.push(...list);
            // 关闭 modal
            this.modalRef.close(this.finalSelects);
        };
    }
}
